import {NodePlopAPI} from "plop";
import nestGenerators from "./nest";

export default function generators(plop: NodePlopAPI) {
    nestGenerators(plop);
}
